import { Hero } from '../components/Hero';
import { Manifesto } from '../components/Manifesto';
import { Services } from '../components/Services';
import { FeaturedLivestock } from '../components/FeaturedLivestock';
import { Stats } from '../components/Stats';
import { Marquee } from '../components/Marquee';
import { Testimonials } from '../components/Testimonials';

export const Home = () => {
  return (
    <div>
      <Hero />
      <Marquee />
      <Manifesto />
      <Services />
      <Stats />
      <FeaturedLivestock />
      {/* <Testimonials /> */}
    </div>
  );
};
